import { CHAPROOM_FEATURES, CHAPROOM_MODULE } from '../modules/chaproom';

/**
 * قابلیت‌های اختصاصی شرکت‌ها بر اساس ماژول‌های فعال شرکت (company_modules در پاسخ لاگین).
 * به‌جای پخش if(company_id) در UI، از hasCompanyFeature استفاده کنید.
 */
const MODULE_FEATURES = {
  [CHAPROOM_MODULE]: CHAPROOM_FEATURES,
};

/**
 * نشست‌هایی که قبل از اضافه شدن company_modules لاگین کرده‌اند این فیلد را ندارند؛
 * تا لاگین بعدی، چاپروم (company_id=15) از این نگاشت شناخته می‌شود.
 */
const LEGACY_COMPANY_MODULES = {
  15: [CHAPROOM_MODULE],
};

/** ماژول‌های اختصاصی فعال برای شرکت کاربر */
export const getCompanyModules = (user) => {
  if (Array.isArray(user?.company_modules)) return user.company_modules;
  if (user?.company_id == null) return [];
  return LEGACY_COMPANY_MODULES[Number(user.company_id)] || [];
};

export const hasCompanyModule = (user, moduleName) => getCompanyModules(user).includes(moduleName);

export const hasCompanyFeature = (user, feature) => {
  if (!feature) return false;
  return getCompanyModules(user).some((moduleName) =>
    (MODULE_FEATURES[moduleName] || []).includes(feature),
  );
};
